<div class="fixed bottom-5 right-5 flex flex-col gap-2 z-[100] pointer-events-none">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="nx-toast-enter flex items-start gap-3 px-4 py-3 rounded-lg border pointer-events-auto max-w-sm overflow-hidden"
         [class]="toastClass(toast)">
      <lucide-icon [img]="toastIcon(toast)" class="w-4 h-4 shrink-0 mt-0.5"/>
      <span class="flex-1 min-w-0 text-xs leading-relaxed break-words">{{ toast.message }}</span>
      <button (click)="toastService.dismiss(toast.id)" class="shrink-0 opacity-60 hover:opacity-100 transition-opacity ml-1">
        <lucide-icon [img]="XIcon" class="w-3.5 h-3.5"/>
      </button>
    </div>
  }
</div>
